import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { axiosBaseQuery } from './AxiosBaseQuery';
import { API_SERVER_URL } from '@/constants/Config';

export interface IOrderReviewResponse {
  order_item_id: string;
  rating: number;
}

export interface ITransformedOrderReviewResponse {
  [key: string]: number;
}

export const orderReviewQuery = createApi({
  reducerPath: 'orderReviewQuery',
  baseQuery: axiosBaseQuery({
    baseUrl: API_SERVER_URL,
    headers: {
      'Content-type': 'multipart/form-data',
    },
  }),
  endpoints: (build) => ({
    getOrderReview: build.query({
      query: (data) => ({
        url: `api/review/getReview?orderItemIds=${data}`,
        method: 'get',
      }),
      transformResponse: (response: IOrderReviewResponse[]) => {
        const transformedData = response.reduce((acc: ITransformedOrderReviewResponse, item) => {
          acc[item.order_item_id] = item.rating || 0;
          return acc;
        }, {});

        return transformedData;
      },
    }),
    createOrderReview: build.mutation({
      query: (data) => ({
        url: `api/review/createReview`,
        method: 'post',
        data,
      }),
    }),
  }),
});

export const { useGetOrderReviewQuery, useCreateOrderReviewMutation } = orderReviewQuery;
